'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScrollManager = undefined;

var _windowScrollManager = require('window-scroll-manager');

var _windowScrollManager2 = _interopRequireDefault(_windowScrollManager);

var _Plx = require('./Plx');

var _Plx2 = _interopRequireDefault(_Plx);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Plx2.default;
exports.ScrollManager = _windowScrollManager2.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-plx/lib/index.js
// module id = 117
// module chunks = 21924764633174 35783957827783 105554497264463